var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"area-indicator"},[_c('LabelWithValue',{attrs:{"label":'Área polígono',"value":_vm.polygonsArea,"loading":_vm.calculatingPolygonArea}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }